import { PointModel } from 'storm-react-diagrams';
import { BaseLinkModel } from './BaseLinkModel';

export default class BasePointModel extends PointModel {
  constructor(link: BaseLinkModel, points: { x: number; y: number; }) {
    super(link, points);
  }

  /**
   * Return a simplified serialization with useless bits removed
   * Also remove circular reference
   */
  serialize(): any {
    return {
      x: this.x,
      y: this.y
    };
  }
}
